<template>
  <div id="common">
    <div class="msgSend">
      <div class="topPart">
        <h2 class="title">通知推送</h2>
        <div class="intro">
         智慧消防系统结合多种通知分发手段，确保第一时间将报警、故障等重要信息推送给制定用户
        </div>
      </div>
      <el-row class="elRow">
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" align="center">
          <img src="../../../assets/img/product/msg.png" alt="" />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" align="center">
          <div class="sendTypeBox">
            <div
              v-for="(item, index) in sendTypeArr"
              :key="index"
              class="typeItem wow animate__zoomIn"
              :style="{ 'margin-top': index % 2 !== 0 ? 0 : '3rem' }"
            >
              <img :src="item.src" alt="" />
              <div class="typeName">{{ item.name }}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- <div class="bigScreen" style="display:none">
      <el-row :gutter="50">
        <el-col :xs="24" class="hidden-sm-and-up" align="center">
          <img src="../../../assets/img/product/daping.png" alt="" />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" align="left">
          <div class="itemTech wow fadeInUp">
            <div class="title1">快速体验我们的</div>
            <h2 class="title2">可视化大屏系统。</h2>
            <div class="line"></div>
            <div class="content">
              铁辰智慧消防系统应用地理信息技术（GIS ）
              ，帮助用户直观查看建筑分层/区域结构、设备点位、视频分布、设施间位置关系等情况。支持按用户需求，现场采集信息
              、 绘制地图，支持多类型地图集成，支持各类设备设施标注 。
            </div>
            <div class="inBtn">点击进入</div>
          </div>
        </el-col>
        <el-col
          :xs="24"
          :sm="12"
          :md="12"
          :lg="12"
          :xl="12"
          align="center"
          class="hidden-xs-only"
        >
          <img src="../../../assets/img/product/daping.png" alt="" />
        </el-col>
      </el-row>
    </div> -->

    <div class="bigScreen xfApp">
      <el-row>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" align="left">
          <img src="../../../assets/img/product/APP.png" alt="" />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" align='center'>
          <div class="itemTech wow fadeInUp">
            <h2 class="title2">铁辰掌上智慧消防App</h2>
            <div class="title1">您的掌上智慧消防管家</div>
            <div class="content">
              <div class="appItem">
                <img src="../../../assets/img/about/dh.png" alt="" />
                <div class="appTxt">点位信息、实时状态 </div>
              </div>
              <div class="appItem">
                <img src="../../../assets/img/about/dh.png" alt="" />
                <div class="appTxt">
                  实时/历史报警信息 
                </div>
              </div>
              <div class="appItem">
                <img src="../../../assets/img/about/dh.png" alt="" />
                <div class="appTxt">历史数据图表展示 </div>
              </div>
              <div class="appItem">
                <img src="../../../assets/img/about/dh.png" alt="" />
                <div class="appTxt">消息通知推送</div>
              </div>
              <div class="appItem">
                <img src="../../../assets/img/about/dh.png" alt="" />
                <div class="appTxt">视频查看、联动 </div>
              </div>
              <div class="appItem">
                <img src="../../../assets/img/about/dh.png" alt="" />
                <div class="appTxt">消防巡检、隐患管理 </div>
              </div>
            </div>
            <div class="downType">
              <el-popover
                placement="bottom"
                width="110"
                height="110"
                trigger="click"
              >
                <img
                  src="../../../assets/img/footer/ceshi.jpg"
                  alt=""
                  class="erweima"
                  style="height: 100%; width: 100%"
                />
                <el-button slot="reference" class="downItem">
                  <img
                    src="../../../assets/img/product/ios.svg"
                    alt=""
                    class="downIcon"
                  />
                  <div class="downName">IOS下载</div>
                </el-button>
              </el-popover>
              <el-popover
                placement="bottom"
                width="110"
                height="110"
                trigger="click"
              >
                <img
                  src="../../../assets/img/footer/ceshi.jpg"
                  alt=""
                  class="erweima"
                  style="height: 100%; width: 100%"
                />
                <el-button slot="reference" class="downItem">
                  <img
                    src="../../../assets/img/product/android.svg"
                    alt=""
                    class="downIcon"
                  />
                  <div class="downName">Android下载</div>
                </el-button>
              </el-popover>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
export default {
  props: {},
  data() {
    return {
      sendTypeArr: [
        {
          name: "微信推送",
          src: require("../../../assets/img/product/weixin.svg"),
        },
        {
          name: "电话推送",
          src: require("../../../assets/img/product/dianhua.svg"),
        },
        {
          name: "短信推送",
          src: require("../../../assets/img/product/duanxin.svg"),
        },
        {
          name: "邮件推送",
          src: require("../../../assets/img/product/youjian.svg"),
        },
      ],
    };
  },
  computed: {},
  created() {},
  mounted() {
    new WOW({ live: false}).init();
  },
  watch: {},
  methods: {},
  components: {},
};
</script>

<style scoped lang="scss">
#common {
  .topPart {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 3rem;
    .title {
      font-size: 2.6rem;
      color: #333333;
      margin-bottom: 1rem;
    }
    .intro {
      width: 60%;
      color: #999999;
      font-size: 1.4rem;
      line-height: 2.2rem;
      text-align: center;
    }
  }
  .msgSend {
    padding: 5% 14%;
    img {
      //   height: 40rem;
      width: 70%;
    }
    .elRow {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin-top: 7rem;
    }
    .sendTypeBox {
      display: flex;
      flex-wrap: wrap;
      width: 80%;
      justify-content: space-evenly;
      .typeItem {
        width: 20rem;
        height: 20rem;
        padding: 2rem;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        background: #ffffff;
        border-radius: 8px;
        margin-left: 2rem;

        &:hover {
          box-shadow: 0px 1rem 2rem 0px rgba(48, 55, 66, 0.15);
          transform: translate(0, -5px);
          transition: all 0.3s;
        }
        img {
          width: 7rem;
          height: 7rem;
          background: #7eabe8;
          border-radius: 50%;
        }
        .typeName {
          font-size: 1.5rem;
          font-weight: 500;
          color: #333333;
          margin-top: 2rem;
          font-weight: 600;
        }
      }
    }
    
  }
  .xfApp {
    background: #f6f8fa;
  }
  .bigScreen {
    padding: 5% 14%;
    img {
      height: 50rem;
      width: 90%;
      object-fit: contain;
    }
    .itemTech {
      height: 46rem;
      padding: 1rem;
      width: 70%;
      .title1 {
        font-size: 1.4rem;
        font-weight: 500;
        color: #666666;
        line-height: 4.2rem;
        text-align: left;
      }
      .title2 {
        color: #333333;
        line-height: 5rem;
        font-size: 2.6rem;
        text-align: left;
      }
      .content {
        color: #777777;
        width: 100%;
        margin-top: 2rem;
        text-align: left;
        .appItem {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-bottom: 1.4rem;
          img {
            width: 2rem;
            height: 2rem;
            margin-right: 1rem;
          }
          .appTxt{
            font-size: 1.4rem;
          }
        }
      }
      .inBtn {
        width: 15rem;
        height: 5rem;
        background: linear-gradient(
          125deg,
          rgba(0, 183, 164, 0.8),
          rgba(13, 202, 129, 0.8)
        );
        box-shadow: 0px 10px 30px 0px rgba(61, 127, 220, 0.24);
        border-radius: 3rem;
        font-size: 1.8rem;
        font-weight: bold;
        color: #ffffff;
        line-height: 4rem;
        margin-top: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .downType {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-top: 3rem;
        .downItem {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          background: #ffffff;
          box-shadow: 0px 5px 76px 0px rgba(194, 194, 194, 0.58);
          border-radius: 4px;
          width: 18rem;
          height: 8rem;
          margin-right: 4rem;
          padding: 0px 1rem;
          cursor: pointer;
          border: none;
          .downIcon {
            width: 3.6rem;
            height: 3.6rem;
            float: left;
            margin-right: 1rem;
          }
          .downName {
            font-size: 1.6rem;
            font-weight: bold;
            color: #666666;
            line-height: 2rem;
            float: left;
            margin-top: 0.8rem;
          }
        }
      }
      
    }
    
  }
  
}
@import '../../../assets/responsive/common.scss';
</style>
